import React, {useEffect, useState} from "react";
import jQuery from 'jquery'
import AboutUs from "./components/AboutUs/AboutUs";
import Footer from "./components/Footer/Footer";
import AuthService from "./services/auth.service";
import Books from "./components/Books";
import Navbar from "./components/Navbar";

window.jQuery = jQuery;

function App() {
    const [currentUser, setCurrentUser] = useState(undefined);
    const [booksLike, setBooksLike] = useState('')
    const [authorsLike, setAuthorsLike] = useState('')

    useEffect(() => {
        // Define the async function inside the effect
        const checkAuthStatus = async () => {
            let user;
            if (localStorage.getItem('token')) {
                try { // Add try...catch for potential errors during checkAuth
                    user = await AuthService.checkAuth();
                } catch (error) {
                    console.error("Error during auth check:", error); 
                    // Handle error appropriately, e.g., clear token if invalid
                    // localStorage.removeItem('token'); 
                }
            }
            // Set user state based on the result
            if (user) {
                setCurrentUser(user);
            }
            // Optionally set to null or handle the case where user is not authenticated
            // else {
            //    setCurrentUser(null);
            // }
        };

        // Call the async function
        checkAuthStatus();

    }, []); // Empty dependency array means this runs once on mount

    return (
        <div>
            <Navbar setCurrentUser={setCurrentUser} currentUser={currentUser} booksLike={booksLike} authorsLike={authorsLike} setBooksLike={setBooksLike}
                    setAuthorsLike={setAuthorsLike} />
            <AboutUs />
            <Books setCurrentUser={setCurrentUser} currentUser={currentUser} booksLike={booksLike} authorsLike={authorsLike}/>
            <Footer />
        </div>
    );
}

export default App;
